<header mat-dialog-title>
  <div class="dialog-caption">{{business ? 'Edit' : 'Add'}} business</div>
  <button mat-dialog-close class="btn icon-close"></button>
</header>

<div mat-dialog-content>
  <app-sole-business-form #soleBusinessFormComponent
                          [business]="business"
                          (saved)="dialogRef.close(true)">
  </app-sole-business-form>
</div>

<div mat-dialog-actions>
  <div class="row gx-3 align-h-right">
    <div class="col-6 col-sm-auto">
      <button mat-dialog-close class="btn basic w-100">Cancel</button>
    </div>
    <div class="col-6 col-sm-auto">
      <button [appFormSubmit]="soleBusinessFormComponent" class="btn primary w-100">Save</button>
    </div>
  </div>
</div>
